import { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useMealModel, IOrgTimeItem } from "../mealModel";

import { IMealDetial, IMealOrgs } from "../mealTypes";
import { useDictModel } from "@/views/dict/dictModel";
import { IMealTypeEnum, IMealTypeOptions } from "@/types/AppEnums";
import { mealService } from "../mealService"
export function DataTable() {
    const {
        dataSource, pgCfg,
        loadData, setSelectedRowKeys,
        setIVisibleDrawer,
        setEditFormVal,
        setMealTypeList,
        setOrderInCalel,
        removeDetail,
    } = useMealModel();

    const onEdit = async (record: IMealDetial) => {
        let { retData } = await mealService.one(record.id as string)
        if (retData) {
            let { mealOrgs, mealType, startTimeBook, endTimeBook, startTimeBusiness, cancelMealTime, endTimeBusiness, ...params } = retData as { cancelMealTime: string, mealType: string, startTimeBook: string, endTimeBook: string, startTimeBusiness: string, endTimeBusiness: string, mealOrgs: IMealOrgs[] }
            setEditFormVal({ ...params,mealType })//
            setMealTypeList([mealType as IMealTypeEnum])
            setSelectedRowKeys([record.id as string])
            setOrderInCalel({ startTimeBook, endTimeBook, cancelMealTime,startTimeBusiness,endTimeBusiness })
            setIVisibleDrawer("edit")

        }
    }
    const onRemove = (id: string) => {
        removeDetail(id)
    }
    const columns: ColumnsType<IMealDetial> = [
        {
            title: '序号',
            width: 80,
            render: (text, record, index) => `${index + 1}`,
            fixed: "left"
        }, {
            title: '餐厅名称',
            width: 130,
            dataIndex: 'canteen',
            render: (text) => text?.name
        }, {
            title: '餐别名称',
            width: 130,
            dataIndex: 'mealType',
            render: (text) => IMealTypeOptions.find(item => item.value === text)?.label

        }, {
            title: '营业时间',
            width: 130,
            dataIndex: 'startTimeBusiness',
            render: (text, record) => `${(record.startTimeBusiness as string)}——${(record.endTimeBusiness as string)}`
        }, {
            title: '操作',
            width: 130,
            render: (text, record) => <div>
                <span className="click-span" onClick={() => onEdit(record)}>编辑</span>
                <span className="click-span" onClick={() => onRemove(record.id as string)}>删除</span>
            </div>
        }
    ];


    useEffect(() => {
        loadData()
    }, [])


    return (
        <Table
            rowKey={record => record.id as string}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
